import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { LookupsAddMultipleComponent } from '../lookups-add-multiple/lookups-add-multiple.component';
import { LOOKUP, UpdateLookup } from 'src/app/models/common';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { Subject } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-lookups-modal-edit',
  templateUrl: './lookups-modal-edit.component.html',
  styleUrls: ['./lookups-modal-edit.component.scss']
})
export class LookupsModalEditComponent implements OnInit {
  @Input() public Content: any;
  content: any;
  heading: string;
  isAllowNew: boolean = false;
  lookupList: LOOKUP[];
  lookupListCopy: LOOKUP[];
  hideActive: boolean = false;
  action: Subject<any> = new Subject();
  LookUpType: string;
  LookUpId: string;
  updateLookupList = new UpdateLookup();
  NAME: string;
  PROGRAM: string;

  constructor(
    private modalService: NgbModal,
    public modalRef: NgbActiveModal,
    public modalRefe: NgbActiveModal,
    private summaryService: AdministrationSummaryService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    //debugger;
    if (this.Content.content.IsAllowNew == "Yes" && this.Content.heading == "Edit") {
      this.isAllowNew = true;
    }
    else {
      this.isAllowNew = false;
    }
    this.NAME = this.Content.content.Name;
    this.PROGRAM = this.Content.content.Module;
    this.getLookups();
  }

  getLookups() {
    //debugger;
    this.summaryService.getLookupsSummary(this.Content.content.id).subscribe(summary => {
      this.lookupList = summary;
      this.lookupListCopy = this.lookupList;
    });
  }

  selectDocuments(event, type: any) {
    if (type == 'Edit') {
      let modalRef = this.modalService.open(LookupsAddMultipleComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg ',
        animation: true
      });
      modalRef.componentInstance.Content= {
        heading: 'Edit',

          id: this.Content.content.id,
          ID: event.ID,
          CODE: event.CODE,
          Name: event.NAME,
          NAME: this.NAME,
          PROGRAM: this.PROGRAM,
          EXTENDABLE: event.EXTENDABLE,
          RecordState: event.RECORD_STATE,
          list: this.lookupList

      }
      modalRef.result.then(result => {
        if (result) {
          let isExist = this.lookupList.find(x => x.NAME == result.NAME && x.RECORD_STATE == result.RECORD_STATE);
          if (!isExist) {
            let find = this.lookupList.findIndex(x=>x.ID == result.ID);
            this.lookupList[find].NAME = result.NAME;
            this.lookupList[find].RECORD_STATE = result.RECORD_STATE;
            //this.commonService.SuccessBanner(result.NAME + ' details updated successfully');
          }

          // else {
          //   this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'No changes have been performed' } } });
          // }

        }
      })
    }

    if (type == 'Add') {
      this.isAllowNew = true;
      let modalRef = this.modalService.open(LookupsAddMultipleComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg ',
        animation: true
      });
      modalRef.componentInstance.Content= {
        heading: 'Add',
        id: this.Content.content.id,
          Name: this.NAME,
          PROGRAM: this.PROGRAM,
          list: this.lookupList

      }
      modalRef.result.then(result => {
        let lkpList = [];
        if (result) {
          lkpList.push(result);
          this.lookupList = lkpList.concat(this.lookupList);
        }
      })
    }
  }

  Save(): void {
    this.updateLookupList.lookuplist = [];
    for (let i = 0; i < this.lookupList.length; i++) {
      if (this.lookupList[i].RECORD_STATE)
        this.lookupList[i].RECORD_STATE = 1;
      else
        this.lookupList[i].RECORD_STATE = 0;
    }

    if (this.lookupList.length > 0) {
      this.updateLookupList.lookuplist = this.lookupList;
    }

    this.updateLookupList.LOOKUP_TYPE_NAME = this.NAME;
    this.updateLookupList.ID = this.Content.content.id;
    this.updateLookupList.PROGRAM = this.Content.content.Modulecode;
    if (this.updateLookupList.lookuplist.length >= 1) {
      this.summaryService.updateLookups(this.updateLookupList).subscribe(summary => {
        if (summary.Status === 0) {
          this.commonService.SuccessBanner(this.updateLookupList.LOOKUP_TYPE_NAME + ' details updated successfully');
         // this.action.next();
          this.close();
          this.getLookups();
        } else if (summary.ErrorCode = "DEFAULT012") {
          this.commonService.ValidationBanner(summary.Message);
         //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: summary.Message } } });
        }
        else {
          this.commonService.ErrorBanner(summary.Message);
        }
      });
    } else {
      this.commonService.ValidationBanner("Please add at least one value to save the configuration");
      // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Please add at least one value to save the configuration' } } });
    }
  }

  Delete(event): void {
    // this.modalRef = this.modalService.show(DeleteBoxComponent);
    // this.modalRef.content.action.subscribe(result => {
    //   if (result == 'okclick') {
        this.summaryService.deleteLookups(event).subscribe(summary => {
          if (summary.Status === 0) {
            this.commonService.ValidationBanner(summary.Message);
          }
          else {
            let val = this.lookupList.findIndex(x => x.ID == event.ID);
            if (this.lookupList.length == 1 && this.lookupListCopy.length == 1) {
              this.updateLookupList.LookUp = this.lookupList[0];
            }
            this.lookupList.splice(val, 1);
          }
        });
    //   }
    // });
  }


  listSorted(event: any) {
    // this.lookupList  = {...this.lookupListCopy};
    // this.lookupList = this.lookupListCopy;
   // console.log(event);
  }

  close() {
    this.modalRefe.dismiss();
  }
}
